/**
 * Order, reservation and pickup enums - numeric values mirror the future
 * Marketplace.API contract (HLD §17).
 */

/**
 * Per-retailer order group state machine (HLD §17):
 * Placed → Paid → Staged | Shipped → PickedUp | Delivered → Completed,
 * with Cancelled and Refunded as terminal branches.
 */
export enum OrderGroupStatus {
  Placed = 1,
  Paid = 2,
  Staged = 3,
  Shipped = 4,
  PickedUp = 5,
  Delivered = 6,
  Completed = 7,
  Cancelled = 8,
  Refunded = 9
}

export const OrderGroupStatusLabel: Record<OrderGroupStatus, string> = {
  [OrderGroupStatus.Placed]: 'Placed',
  [OrderGroupStatus.Paid]: 'Paid',
  [OrderGroupStatus.Staged]: 'Ready for Pickup',
  [OrderGroupStatus.Shipped]: 'Shipped',
  [OrderGroupStatus.PickedUp]: 'Picked Up',
  [OrderGroupStatus.Delivered]: 'Delivered',
  [OrderGroupStatus.Completed]: 'Completed',
  [OrderGroupStatus.Cancelled]: 'Cancelled',
  [OrderGroupStatus.Refunded]: 'Refunded'
};

/** Checkout-initiated reservation state (HLD §8.1, D-04). */
export enum ReservationStatus {
  Active = 1,
  Consumed = 2,
  Expired = 3,
  Released = 4
}

export const ReservationStatusLabel: Record<ReservationStatus, string> = {
  [ReservationStatus.Active]: 'Active',
  [ReservationStatus.Consumed]: 'Consumed',
  [ReservationStatus.Expired]: 'Expired',
  [ReservationStatus.Released]: 'Released'
};

/** Pickup ticket lifecycle (HLD §11 `PickupTicket`). */
export enum PickupTicketStatus {
  AwaitingStaging = 1,
  Staged = 2,
  PickedUp = 3,
  Expired = 4
}

export const PickupTicketStatusLabel: Record<PickupTicketStatus, string> = {
  [PickupTicketStatus.AwaitingStaging]: 'Being Prepared',
  [PickupTicketStatus.Staged]: 'Ready for Pickup',
  [PickupTicketStatus.PickedUp]: 'Picked Up',
  [PickupTicketStatus.Expired]: 'Expired'
};
